<template>
  <div role="main">
    <div class="ibox data-filter">
      <div class="ibox-content px-3 pt-3 pb-2">

        <b-form @submit="onSubmitFilter">
          <b-row>
            <b-col cols="12" md="6" lg="4" class="entot-tanggal">
              <label for="filter-select-date" class="sr-only">Date</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <font-awesome-icon icon="calendar-alt" />
                  </div>
                </div>
                <date-range-picker
                  ref="picker"
                  v-bind:opens="dateOption.opens"
                  v-bind:minDate="dateOption.minDate"
                  v-bind:maxDate="dateOption.maxDate"
                  v-bind:locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                  v-bind:singleDatePicker="dateOption.singleDatePicker"
                  v-bind:timePicker="dateOption.timePicker"
                  v-bind:timePicker24Hour="dateOption.timePicker24Hour"
                  v-bind:showWeekNumbers="dateOption.showWeekNumbers"
                  v-bind:showDropdowns="dateOption.showDropdowns"
                  v-bind:ranges="dateOption.ranges_show"
                  v-bind:autoApply="dateOption.autoApply"
                  v-model="dateRange"
                  @update="updateDateRange"
                  v-bind:showCustomRangeCalendars="dateOption.showCustomRangeCalendars"
                  v-bind:linkedCalendars="dateOption.linkedCalendars"
                  v-bind:dateFormat="dateFormat"
                  class="custom-picker"
                >
                  <template v-slot:input="picker">
                    {{ picker.startDate | date }} - {{ picker.endDate | date }}
                  </template>
                </date-range-picker>
              </div>
            </b-col>
            <b-col cols="12" md="6" lg="4">
              <label for="filter-select-date" class="sr-only">ID</label>
              <div class="input-group mb-2">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <font-awesome-icon icon="id-card" />
                  </div>
                </div>
                <input
                  name="click_id"
                  placeholder="Search ID"
                  type="text"
                  id="filter-input-click-id"
                  class="form-control"
                  minlength="2"
                  v-model="filter.user"/>
                <div class="input-group-append">
                  <b-button type="submit" variant="dark">
                    <font-awesome-icon icon="check" /> Apply
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-form>

      </div>
    </div>

    <!--<transition appear appear-active-class="animated fadeIn">-->
      <div class="ibox" v-bind:class="{ full: fullscreen }">
        <div id="d-table-scroll" class="ibox-title">
          <span>
            Tracker
          </span>
          <div class="ibox-tools">
            <div role="group" arial-label="Action" class="btn-group btn-group-sm">
              <b-btn variant="secondary" v-on:click="requestData">
                <font-awesome-icon icon="sync-alt" :spin="processing" />
              </b-btn>
              <b-btn variant="secondary" v-on:click="toogleScreen">
                <font-awesome-icon v-bind:icon="fullscreen ? 'window-minimize' : 'window-maximize'"/>
              </b-btn>
            </div>
          </div>
        </div>

        <div class="ibox-content">
          <b-form v-if="fullscreen" @submit="onSubmitFilter">
            <b-row>
              <b-col cols="12" md="6" lg="4">
                <label for="filter-select-date" class="sr-only">Date</label>
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <font-awesome-icon icon="calendar-alt" />
                    </div>
                  </div>
                  <date-range-picker
                    ref="picker"
                    v-bind:opens="dateOption.opens"
                    v-bind:minDate="dateOption.minDate"
                    v-bind:maxDate="dateOption.maxDate"
                    v-bind:locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
                    v-bind:singleDatePicker="dateOption.singleDatePicker"
                    v-bind:timePicker="dateOption.timePicker"
                    v-bind:timePicker24Hour="dateOption.timePicker24Hour"
                    v-bind:showWeekNumbers="dateOption.showWeekNumbers"
                    v-bind:showDropdowns="dateOption.showDropdowns"
                    v-bind:ranges="dateOption.ranges_show"
                    v-bind:autoApply="dateOption.autoApply"
                    v-model="dateRange"
                    @update="updateDateRange"
                    v-bind:showCustomRangeCalendars="dateOption.showCustomRangeCalendars"
                    v-bind:linkedCalendars="dateOption.linkedCalendars"
                    v-bind:dateFormat="dateFormat"
                    class="custom-picker"
                  >
                    <template v-slot:input="picker">
                      {{ picker.startDate | date }} - {{ picker.endDate | date }}
                    </template>
                  </date-range-picker>
                </div>
              </b-col>
              <b-col cols="12" md="6" lg="4">
                <label for="filter-select-date" class="sr-only">ID</label>
                <div class="input-group mb-2">
                  <div class="input-group-prepend">
                    <div class="input-group-text">
                      <font-awesome-icon icon="id-card" />
                    </div>
                  </div>
                  <input
                    name="click_id"
                    placeholder="Search ID"
                    type="text"
                    id="filter-input-click-id"
                    class="form-control"
                    v-model="filter.user"/>
                  <div class="input-group-append">
                    <b-button type="submit" variant="dark">
                      <font-awesome-icon icon="check" /> Apply
                    </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-form>

          <div class="table-beauty">
            <div class="table-responsive">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th scope="col" class="sorting">
                      ID
                      <a
                        href="#"
                        :class="getOrderByClass( 'click_id' )"
                        v-on:click="toggleOrderBy( $event, 'click_id'  )"/>
                    </th>
                    <th scope="col" class="sorting">
                      Visits
                      <a
                        href="#"
                        :class="getOrderByClass( 'visits' )"
                        v-on:click="toggleOrderBy( $event, 'visits'  )"/>
                    </th>
                    <th scope="col" class="sorting">
                      Unique
                      <a
                        href="#"
                        :class="getOrderByClass( 'unique' )"
                        v-on:click="toggleOrderBy( $event, 'unique'  )"/>
                    </th>
                    <th scope="col" class="sorting">
                      Clicks
                      <a
                        href="#"
                        :class="getOrderByClass( 'clicks' )"
                        v-on:click="toggleOrderBy( $event, 'clicks'  )"/>
                    </th>
                    <th scope="col" class="sorting">
                      Leads
                      <a
                        href="#"
                        :class="getOrderByClass( 'leads' )"
                        v-on:click="toggleOrderBy( $event, 'leads'  )"/>
                    </th>
                    <th scope="col" class="sorting">
                      Payout
                      <a
                        href="#"
                        :class="getOrderByClass( 'payouts' )"
                        v-on:click="toggleOrderBy( $event, 'payouts'  )"/>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="odd" v-if="processing && !table.initial">
                    <td valign="center" colspan="6" class="no-hover">
                      <div class="loading-spinner"><div class="spin">Loading...</div></div>
                    </td>
                  </tr>
                  <tr class="odd" v-if="!table.rows.length && table.initial">
                    <td valign="top" colspan="6" class="no-hover text-center">No data available in table</td>
                  </tr>
                  <template v-for="(item, index) in table.rows">
                    <tr role="row" v-bind:key="item.smartlink" :class="index % 2 ? 'even' : 'odd'">
                      <td class="text-nowrap d-flex align-items-center" v-bind:data-id="item.smartlink">
                        <b-button
                          variant="light"
                          v-if="!!item.childs"
                          @click="toggleChild(item.smartlink)"
                          :class="{ opened: table.opened.includes(item.smartlink) }"
                          type="button"
                          class="btn-ngentot"
                        >
                          <font-awesome-icon icon="angle-right" fixed-width />
                        </b-button>
                        <span>{{ item.smartlink }}</span>
                      </td>
                      <td>{{ item.visits }}</td>
                      <td>{{ item.unique }}</td>
                      <td>{{ item.clicks }}</td>
                      <td>{{ item.leads }}</td>
                      <td>{{ item.payouts | formatMoney }}</td>
                    </tr>
                    <template v-for="childItem in item.childs">
                      <tr v-if="table.opened.includes(item.smartlink)" v-bind:key="childItem.index" v-bind:data-id="childItem.index">
                        <td class="text-nowrap">
                          <span>{{ childItem.country }}</span>
                        </td>
                        <td>{{ childItem.visits }}</td>
                        <td>{{ childItem.unique }}</td>
                        <td>{{ childItem.clicks }}</td>
                        <td>{{ childItem.leads }}</td>
                        <td>{{ childItem.payouts | formatMoney }}</td>
                      </tr>
                    </template>
                  </template>

                  <tr role="row" v-if="table.rows.length && table.initial" :class="table.rows.length % 2 ? 'even' : 'odd'" class="calculate">
                    <td class="text-nowrap">Total : <strong>{{ table.rows.length }}</strong></td>
                    <td><strong>{{ table.total.visits }}</strong></td>
                    <td><strong>{{ table.total.unique }}</strong></td>
                    <td><strong>{{ table.total.clicks }}</strong></td>
                    <td><strong>{{ table.total.leads }}</strong></td>
                    <td><strong>{{ table.total.payouts | formatMoney }}</strong></td>
                  </tr>
                </tbody>
              </table>

              <div class="table-beaury-loading" v-if="processing && table.initial"/>
            </div>
          </div>
        </div>
      </div>
    <!--</transition>-->
  </div>
</template>

<style lang="scss">
  @import "~bootstrap/scss/mixins";
  @import "~vue2-daterange-picker/dist/vue2-daterange-picker.css";

  .calculate td {
    text-decoration: underline;
    border-top: 2px solid #dee2e6;
    border-style: dashed;
  }

  .btn-ngentot {
    background-color: transparent;
    margin-bottom: -0.75rem;
    margin-top: -0.75rem;
    border: none;
    border-radius: 50%;
    padding: 0;
    margin-left: -0.5rem;
    transition-duration: 200ms ease;
    transition-property: transform;
    transform: none;
  }

  .btn-ngentot.opened {
    transform: rotate(90deg);
  }

  .btn-ngentot, .btn-ngentot svg {
    width: 2em;
    height: 2em;
  }

  .custom-picker {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    width: 1%;
    margin-bottom: 0;
  }

  @include media-breakpoint-down(sm) {
    .btn-ngentot {
      margin-top: -0.5rem;
      margin-bottom: -0.5rem;
    }

    .custom-picker {
      .daterangepicker {
        min-width: auto !important;

        &.dropdown-menu {
          width: min-content;
        }

        .calendars-container {
          flex-direction: column;
        }
      }

      .drp-selected {
        padding-right: 0;
        padding-bottom: 5px;
      }

      .col {
        flex-basis: auto;
      }
    }

    .daterangepicker.show-ranges .drp-calendar.left,
    .daterangepicker .drp-calendar.right {
      padding: 0;
    }
  }
</style>

<script>

  const Cookies = require( 'js-cookie' );
  const axios = require('axios');
  const axiosRetry = require('axios-retry');
  const DateRangePicker = require('vue2-daterange-picker').default;
  const moment = require('moment-timezone');

  const CancelToken = axios.CancelToken;
  let cancel;

  function getRandomArbitrary(min, max) {
    return Math.random() * (max - min) + min;
  }

  function fetchPerforms(queryParams) {
    if (cancel) cancel();

    const url = `${process.env.VUE_APP_API_URL}/api/performs`;
    const token = Cookies.get('__token');
    const request = axios.create();

    const requestParams = {
      url,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json; charset=utf-8',
        'Content-Type': 'application/json; charset=utf-8',
      },
      method: 'GET',
      params: { ...queryParams, _: getRandomArbitrary(1, 99) },
      cancelToken: new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
      }),
    };

    axiosRetry(request, { retryDelay: axiosRetry.exponentialDelay });
    request.interceptors.response.use(
      response => {
        cancel = null;
        if (!response.data) {
          throw new Error('Response empty');
        }
        return response.data;
      },
      error => {
        return Promise.reject(error);
      },
    );

    return request(requestParams);
  }

  function formatDataTable(data, options) {
    options = options || {};

    if (options.orderDirection) {
      options.orderDirection = options.orderDirection.toLowerCase();
    }

    const sortData = array => {
      return array.sort((a, b) => {
        if (options.orderDirection === 'desc') {
          return b[options.orderBy] - a[options.orderBy];
        }
        return a[options.orderBy] - b[options.orderBy];
      });
    };

    const groupBy = (array, key) => {
      return array.reduce((accumulator, currentValue, idx) => {
        if (!accumulator[currentValue[key]]) {
          accumulator[currentValue[key]] = [];
        }
        accumulator[currentValue[key]].push({
          index: idx,
          country: currentValue.country,
          clicks: currentValue.clicks,
          payouts: currentValue.payouts,
          leads: currentValue.leads,
          visits: currentValue.visits,
          unique: currentValue.unique,
        });
        return accumulator;
      }, {});
    };

    const groupData = array => {
      const dataMod = [];
      const dataObj = groupBy(array, options.groupBy);
      Object.keys(dataObj).forEach(key => {
        const item = dataObj[key].reduce((accumulator, currentValue) => {
          const values = {
            clicks: accumulator.clicks + currentValue.clicks,
            payouts: accumulator.payouts + currentValue.payouts,
            leads: accumulator.leads + currentValue.leads,
            visits: accumulator.visits + currentValue.visits,
            unique: accumulator.unique + currentValue.unique,
          };
          return values;
        }, { clicks: 0, payouts: 0, leads: 0, visits: 0, unique: 0 });
        if (options.orderBy) {
          const childs = sortData(dataObj[key]);
          dataMod.push({ smartlink: key, ...item, childs });
        }
        else {
          dataMod.push({ smartlink: key, ...item, childs: dataObj[key] });
        }
      });

      return dataMod;
    };

    if (options.groupBy) {
      data = groupData(data);
    }

    if (options.orderBy) {
      data = sortData(data);
    }

    return data;
  }

  export default {
    components: { DateRangePicker },
    mounted () {
      this.$refs.picker.open = false;
    },
    data () {
      const dateNow = new Date();
      return {
        dateNow,
        dateRange: {
          startDate: moment(dateNow).toDate(),
          endDate: moment(dateNow).toDate(),
        },
        dateOption: {
          minDate: moment(dateNow).subtract(2, 'M').toDate(),
          maxDate: moment(dateNow).toDate(),
          opens: 'right',
          ranges_show: {
            'Today': [moment(dateNow).toDate(), moment(dateNow).toDate()],
            'Yesterday': [
              moment(dateNow).subtract(1, 'd').toDate(),
              moment(dateNow).subtract(1, 'd').toDate()
            ],
            'Weekly': [
              moment(dateNow).isoWeekday(1).startOf('d').toDate(),
              moment(dateNow).isoWeekday(1).add(1, 'w').endOf('d').toDate()
            ],
            'Lastweek': [
              moment(dateNow).isoWeekday(1).subtract(1, 'w').startOf('d').toDate(),
              moment(dateNow).isoWeekday(1).subtract(1, 'w').add(1, 'w').endOf('d').toDate()
            ],
            'This Month': [moment(dateNow).startOf('M').toDate(), moment(dateNow).endOf('M').toDate()],
            'Last Month': [
              moment(dateNow).subtract(1, 'M').startOf('M').toDate(),
              moment(dateNow).subtract(1, 'M').endOf('M').toDate()
            ],
            'Last 30 Days': [moment(dateNow).subtract(29, 'd').toDate(), moment(dateNow).toDate()],
          },
          showCustomRangeCalendars: true,
          singleDatePicker: false,
          timePicker: false,
          timePicker24Hour: false,
          showWeekNumbers: false,
          showDropdowns: false,
          autoApply: true,
          linkedCalendars: true,
          alwaysShowCalendars: false
        },
        processing: false,
        fullscreen: false,
        filter: {
          date: 'today',
          user: ''
        },
        table: {
          initial: false,
          total: {
            leads: 0,
            visits: 0,
            unique: 0,
            clicks: 0,
            payouts: 0
          },
          opened: [],
          tempRow: [],
          rows: [],
          orderBy: {
            key: 'payouts',
            type: 'desc'
          }
        },
      };
    },
    created() {
      this.requestData();
    },
    filters: {
      uppercase(value) {
        if (!value) return '';
        return value.toUpperCase();
      },
      date(value) {
        if (!value) return '';
        return moment(value).format('DD/MM/YYYY');
      },
      formatMoney(value) {
        if (!value) return '$0.0000';
        return `$${value.toFixed(4)}`;
      }
    },
    methods: {
      updateDateRange(values) {
        const fidexDate = value => {
          const format = moment(value);
          return moment(value).set({
            'year': format.get('year'),
            'month': format.get('month'),
            'date': format.get('date'),
          });
        };

        this.dateRange.startDate = fidexDate(values.startDate);
        this.dateRange.endDate = fidexDate(values.endDate);

        this.requestData();
      },
      dateFormat(classes) {
        let lastYear = moment(this.dateNow).subtract(1, 'y');
        if (!classes.disabled) {
          classes.disabled = moment(this.dateNow).isSame(lastYear, 'y');
        }
        return classes;
      },
      toggleChild(id) {
        const index = this.table.opened.indexOf(id);
        if (index > -1) {
          this.table.opened.splice(index, 1)
        } else {
          this.table.opened.push(id)
        }
      },
      getOrderByClass( key ) {
        const typeToClass = ( src ) => {
          if ( src === 'desc' ) {
            return 'sorting_desc';
          }
          if ( src === 'asc' ) {
            return 'sorting_asc';
          }
        };

        if ( this.table.orderBy.key === key ) {
          return typeToClass( this.table.orderBy.type );
        }

        return 'sorting';
      },
      toggleOrderBy( event, key ) {
        let type = 'desc';

        if ( this.table.orderBy.key === key ) {
          if ( this.table.orderBy.type === 'desc' ) {
            type = 'asc';
          }
          else {
            type = 'desc';
          }
        }

        if ( event.preventDefault ) {
          event.preventDefault();
        }

        this.table.opened = [];
        this.table.orderBy = { type, key };
        this.renderTable();
      },
      renderTable() {
        this.table.total = {
          leads: 0,
          visits: 0,
          unique: 0,
          clicks: 0,
          payouts: 0
        };
        this.table.rows = formatDataTable(this.table.tempRow, {
          orderBy: this.table.orderBy.key,
          orderDirection: this.table.orderBy.type,
          groupBy: 'smartlink'
        }).map(item => {
          this.table.total.leads += item.leads;
          this.table.total.visits += item.visits;
          this.table.total.unique += item.unique;
          this.table.total.clicks += item.clicks;
          this.table.total.payouts += item.payouts;
          return item;
        }).filter(
          x => x.smartlink
            .toLowerCase()
            .includes(this.filter.user.toLowerCase())
        );
      },
      requestData() {
        const dateStart = moment(this.dateRange.startDate).tz('UTC').format('YYYY-MM-DD');
        const dateEnd = moment(this.dateRange.endDate).tz('UTC').format('YYYY-MM-DD');

        this.processing = true;
        this.table.tempRow = [];
        const fetchAndCollect = (offset) => {
          const queryParams = { start_date: dateStart, end_date: dateEnd };
          if (offset) queryParams.offset = offset;

          return fetchPerforms(queryParams).then(response => {
            this.table.tempRow = [ ...this.table.tempRow, ...response.data ];
            const havePage = response.pagination && response.pagination.next;
            if (!havePage) return response;
            return fetchAndCollect(response.pagination.next);
          });
        };

        fetchAndCollect().then(() => {
          this.renderTable();
          if (false === this.table.initial) this.table.initial = true;
          this.processing = false;
        }).catch(error => {
          if (false === axios.isCancel(error)) {
            if (false === this.table.initial) this.table.initial = true;
            this.processing = false;
          }

          if (!error.response) {
            return;
          }

          const response = error.response;
          if (response.status == 401 || response.status == 403) {
            this.$store.dispatch('authentication/logout');
            this.$router.push('/login');
          }
        });
      },
      toogleScreen() {
        if (this.fullscreen) {
          this.fullscreen = false;
          window.document.body.style.overflow = 'initial';
        }
        else {
          this.fullscreen = true;
          window.document.body.style.overflow = 'hidden';
        }
      },
      onSubmitFilter( event ) {
        event.preventDefault();
        this.renderTable();
      }
    },
    beforeRouteLeave( to, from, next ) {
      this.processing = true;
      next();
    }
  };
</script>